import { PASSWORD_MIN_LENGTH } from '@/shared/config/password';


export interface PasswordRule {
    id: string;
    label: string;
    passed: boolean;
}


export type PasswordLevel = 'empty' | 'weak' | 'medium' | 'strong';


export interface PasswordStrengthResult {
    value: number;       // 0–100
    level: PasswordLevel;
    rules: PasswordRule[];
    isValid: boolean;    // все правила прошли
}


const RULES: Array<{ id: string; label: string; test: (v: string) => boolean }> = [
    {
        id   : '8chars',
        label: `${ PASSWORD_MIN_LENGTH }+ characters`,
        test : (v) => v.length >= PASSWORD_MIN_LENGTH,
    },
    {
        id   : 'upperLower',
        label: 'Contain upper / lowercase',
        test : (v) => /[A-Z]/.test(v) && /[a-z]/.test(v),
    },
    {
        id   : 'number',
        label: 'Contain number',
        test : (v) => /[0-9]/.test(v),
    },
    // {
    //     id   : 'special',
    //     label: `Contain a special character ${ SPECIAL_CHARS }`,
    //     test : (v) => specialCharsRegexp.test(v),
    // },
];

export function usePasswordStrength (password: string): PasswordStrengthResult {
    if (!password) {
        return {
            value  : 0,
            level  : 'empty',
            rules  : RULES.map(({ id, label }) => ({ id, label, passed: false })),
            isValid: false,
        };
    }

    const rules: PasswordRule[] = RULES.map(({ id, label, test }) => ({
        id,
        label,
        passed: test(password),
    }));

    const passedCount = rules.filter((r) => r.passed).length;
    const value       = Math.round((passedCount / rules.length) * 100);

    let level: PasswordLevel;
    if (passedCount <= 1) level = 'weak';
    else if (passedCount <= 2) level = 'medium';
    // else if (passedCount <= 3) level = 'medium';
    else level = 'strong';

    return {
        value,
        level,
        rules,
        isValid: passedCount === rules.length,
    };
}
